import React, { useState, useEffect, useRef } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../../components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { Textarea } from '../../components/ui/textarea';
import PaquetesTuristicosManager from '../../components/admin/PaquetesTuristicosManager';
import PrestadorPreviewCard from '../../components/admin/PrestadorPreviewCard';
import { RuedaImportacionTab } from '../../components/admin/rueda/RuedaImportacionTab';
import { 
  Gift, 
  Plus, 
  Pencil, 
  Trash2, 
  Loader2,
  FolderOpen,
  Building2,
  FileText,
  AlertCircle,
  CheckCircle,
  Palmtree,
  Bus,
  Hotel,
  Tent,
  GraduationCap,
  Waves,
  Shirt,
  Dumbbell,
  Upload,
  X,
  Image,
  Settings,
  Download,
  FileJson,
  RefreshCw,
  Database,
  // Iconos adicionales para categorías
  Eye,
  Laptop,
  ShoppingBag,
  Heart,
  Home,
  Car,
  Plane,
  Ship,
  Train,
  Bike,
  Coffee,
  Utensils,
  Pizza,
  Wine,
  Beer,
  Cake,
  Apple,
  Leaf,
  Sun,
  Moon,
  Star,
  Sparkles,
  Zap,
  Flame,
  Droplet,
  Snowflake,
  Cloud,
  Umbrella,
  Music,
  Headphones,
  Camera,
  Film,
  Tv,
  Monitor,
  Smartphone,
  Tablet,
  Watch,
  Glasses,
  Briefcase,
  Wallet,
  CreditCard,
  Banknote,
  PiggyBank,
  TrendingUp,
  Target,
  Award,
  Trophy,
  Crown,
  Gem,
  Scissors,
  Paintbrush,
  Palette,
  Pen,
  Book,
  BookOpen,
  Library,
  Newspaper,
  FileCheck,
  Clipboard,
  Calculator,
  Percent,
  Tag,
  Tags,
  Bookmark,
  Flag,
  MapPin,
  Map,
  Compass,
  Globe,
  Building,
  Castle,
  Church,
  Landmark,
  Store,
  ShoppingCart,
  Package,
  Search,
  Truck,
  Anchor,
  Rocket,
  Wifi,
  Plug,
  Lightbulb,
  Stethoscope,
  Pill,
  Syringe,
  Activity,
  HeartPulse,
  Brain,
  Bone,
  Footprints,
  Baby,
  Dog,
  Cat,
  Bird,
  Fish,
  Flower,
  TreePine,
  Mountain,
  Sailboat,
  Gamepad2,
  Dices,
  Puzzle,
  Hammer,
  Wrench,
  Cog,
  Key,
  Lock,
  Shield,
  BadgeCheck,
  Users,
  Accessibility,
  Smile,
  PartyPopper,
  Box,
  Send,
  Mail,
  MessageCircle,
  Phone,
  Bell,
  AlarmClock,
  Timer,
  Clock,
  Calendar,
  CalendarDays,
  Sunrise,
  Sunset,
  CircleDollarSign
} from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Mapeo de iconos - Ampliado para más opciones
const iconMap = {
  // Turismo y Viajes
  Palmtree, Bus, Hotel, Tent, Plane, Ship, Train, Car, Bike, Anchor, Sailboat, Compass, Map, MapPin, Globe, Mountain,
  // Salud y Bienestar
  Heart, HeartPulse, Activity, Stethoscope, Pill, Syringe, Brain, Bone, Eye, Glasses, Smile, Accessibility,
  // Deportes y Fitness
  Dumbbell, Gamepad2, Trophy, Award, Target, Footprints,
  // Educación y Cultura
  GraduationCap, Book, BookOpen, Library, Newspaper, Pen, Paintbrush, Palette, Music, Headphones, Film, Camera, Tv,
  // Comercio y Finanzas
  ShoppingBag, ShoppingCart, Store, Tag, Tags, Percent, CreditCard, Wallet, Banknote, PiggyBank, Briefcase, Package, CircleDollarSign,
  // Tecnología
  Laptop, Monitor, Smartphone, Tablet, Watch, Wifi, Plug, Lightbulb, Cog, Wrench, Hammer,
  // Gastronomía
  Utensils, Coffee, Pizza, Wine, Beer, Cake, Apple,
  // Naturaleza
  Leaf, TreePine, Flower, Sun, Moon, Star, Waves, Droplet, Snowflake, Cloud, Umbrella, Flame,
  // Hogar y Familia
  Home, Baby, Dog, Cat, Bird, Fish, Users,
  // Edificios
  Building, Building2, Castle, Church, Landmark,
  // Comunicación
  Mail, MessageCircle, Phone, Send, Bell,
  // Tiempo
  Clock, Calendar, CalendarDays, Timer, AlarmClock, Sunrise, Sunset,
  // Otros
  Gift, Sparkles, Zap, Crown, Gem, Scissors, Shield, BadgeCheck, Key, Lock, PartyPopper, Box, Rocket, Dices, Puzzle,
  // Ropa
  Shirt, TrendingUp, Truck, Flag, Bookmark, Clipboard, Calculator, FileCheck,
};

const iconOptions = [
  // ===== TURISMO Y VIAJES =====
  { value: 'Palmtree', label: '🌴 Palmera (Turismo)', category: 'Turismo' },
  { value: 'Plane', label: '✈️ Avión (Viajes)', category: 'Turismo' },
  { value: 'Hotel', label: '🏨 Hotel (Hospedaje)', category: 'Turismo' },
  { value: 'Tent', label: '⛺ Carpa (Camping)', category: 'Turismo' },
  { value: 'Bus', label: '🚌 Bus (Transporte)', category: 'Turismo' },
  { value: 'Train', label: '🚆 Tren', category: 'Turismo' },
  { value: 'Ship', label: '🚢 Barco (Cruceros)', category: 'Turismo' },
  { value: 'Car', label: '🚗 Auto (Alquiler)', category: 'Turismo' },
  { value: 'Sailboat', label: '⛵ Velero', category: 'Turismo' },
  { value: 'Mountain', label: '⛰️ Montaña', category: 'Turismo' },
  { value: 'Compass', label: '🧭 Brújula', category: 'Turismo' },
  { value: 'Map', label: '🗺️ Mapa', category: 'Turismo' },
  { value: 'MapPin', label: '📍 Ubicación', category: 'Turismo' },
  { value: 'Globe', label: '🌍 Globo', category: 'Turismo' },
  { value: 'Anchor', label: '⚓ Ancla', category: 'Turismo' },
  
  // ===== SALUD Y BIENESTAR =====
  { value: 'Heart', label: '❤️ Corazón (Salud)', category: 'Salud' },
  { value: 'HeartPulse', label: '💓 Pulso', category: 'Salud' },
  { value: 'Activity', label: '📈 Actividad', category: 'Salud' },
  { value: 'Stethoscope', label: '🩺 Estetoscopio', category: 'Salud' },
  { value: 'Pill', label: '💊 Pastilla (Farmacia)', category: 'Salud' },
  { value: 'Syringe', label: '💉 Jeringa', category: 'Salud' },
  { value: 'Eye', label: '👁️ Ojo (Óptica)', category: 'Salud' },
  { value: 'Glasses', label: '👓 Anteojos', category: 'Salud' },
  { value: 'Brain', label: '🧠 Cerebro', category: 'Salud' },
  { value: 'Bone', label: '🦴 Hueso', category: 'Salud' },
  { value: 'Smile', label: '😊 Sonrisa (Odontología)', category: 'Salud' },
  { value: 'Accessibility', label: '♿ Accesibilidad', category: 'Salud' },
  { value: 'Waves', label: '🌊 Olas (Termas/Spa)', category: 'Salud' },
  
  // ===== DEPORTES Y FITNESS =====
  { value: 'Dumbbell', label: '🏋️ Pesa (Gimnasio)', category: 'Deportes' },
  { value: 'Bike', label: '🚴 Bicicleta', category: 'Deportes' },
  { value: 'Trophy', label: '🏆 Trofeo', category: 'Deportes' },
  { value: 'Award', label: '🎖️ Premio', category: 'Deportes' },
  { value: 'Target', label: '🎯 Objetivo', category: 'Deportes' },
  { value: 'Gamepad2', label: '🎮 Gaming', category: 'Deportes' },
  { value: 'Footprints', label: '👣 Huellas (Running)', category: 'Deportes' },
  
  // ===== EDUCACIÓN Y CULTURA =====
  { value: 'GraduationCap', label: '🎓 Birrete (Educación)', category: 'Educación' },
  { value: 'Book', label: '📕 Libro', category: 'Educación' },
  { value: 'BookOpen', label: '📖 Libro Abierto', category: 'Educación' },
  { value: 'Library', label: '📚 Biblioteca', category: 'Educación' },
  { value: 'Newspaper', label: '📰 Diario', category: 'Educación' },
  { value: 'Pen', label: '🖊️ Lapicera', category: 'Educación' },
  { value: 'Paintbrush', label: '🖌️ Pincel (Arte)', category: 'Educación' },
  { value: 'Palette', label: '🎨 Paleta', category: 'Educación' },
  { value: 'Music', label: '🎵 Música', category: 'Educación' },
  { value: 'Headphones', label: '🎧 Auriculares', category: 'Educación' },
  { value: 'Film', label: '🎬 Cine', category: 'Educación' },
  { value: 'Camera', label: '📷 Cámara', category: 'Educación' },
  { value: 'Tv', label: '📺 TV', category: 'Educación' },
  
  // ===== COMERCIO Y FINANZAS =====
  { value: 'ShoppingBag', label: '🛍️ Bolsa (Comercio)', category: 'Comercio' },
  { value: 'ShoppingCart', label: '🛒 Carrito', category: 'Comercio' },
  { value: 'Store', label: '🏪 Tienda', category: 'Comercio' },
  { value: 'Tag', label: '🏷️ Etiqueta', category: 'Comercio' },
  { value: 'Tags', label: '🏷️ Etiquetas', category: 'Comercio' },
  { value: 'Percent', label: '% Porcentaje (Descuento)', category: 'Comercio' },
  { value: 'CreditCard', label: '💳 Tarjeta', category: 'Comercio' },
  { value: 'Wallet', label: '👛 Billetera', category: 'Comercio' },
  { value: 'Banknote', label: '💵 Billete', category: 'Comercio' },
  { value: 'PiggyBank', label: '🐷 Alcancía (Ahorro)', category: 'Comercio' },
  { value: 'Briefcase', label: '💼 Maletín', category: 'Comercio' },
  { value: 'Package', label: '📦 Paquete', category: 'Comercio' },
  { value: 'CircleDollarSign', label: '💲 Dólar', category: 'Comercio' },
  { value: 'TrendingUp', label: '📈 Tendencia', category: 'Comercio' },
  
  // ===== TECNOLOGÍA =====
  { value: 'Laptop', label: '💻 Laptop (Tecnología)', category: 'Tecnología' },
  { value: 'Monitor', label: '🖥️ Monitor', category: 'Tecnología' },
  { value: 'Smartphone', label: '📱 Celular', category: 'Tecnología' },
  { value: 'Tablet', label: '📲 Tablet', category: 'Tecnología' },
  { value: 'Watch', label: '⌚ Reloj', category: 'Tecnología' },
  { value: 'Wifi', label: '📶 WiFi', category: 'Tecnología' },
  { value: 'Plug', label: '🔌 Enchufe', category: 'Tecnología' },
  { value: 'Lightbulb', label: '💡 Lamparita', category: 'Tecnología' },
  { value: 'Cog', label: '⚙️ Engranaje', category: 'Tecnología' },
  { value: 'Wrench', label: '🔧 Llave', category: 'Tecnología' },
  { value: 'Hammer', label: '🔨 Martillo', category: 'Tecnología' },
  
  // ===== GASTRONOMÍA =====
  { value: 'Utensils', label: '🍴 Cubiertos (Gastronomía)', category: 'Gastronomía' },
  { value: 'Coffee', label: '☕ Café', category: 'Gastronomía' },
  { value: 'Pizza', label: '🍕 Pizza', category: 'Gastronomía' },
  { value: 'Wine', label: '🍷 Vino', category: 'Gastronomía' },
  { value: 'Beer', label: '🍺 Cerveza', category: 'Gastronomía' },
  { value: 'Cake', label: '🎂 Torta', category: 'Gastronomía' },
  { value: 'Apple', label: '🍎 Manzana', category: 'Gastronomía' },
  
  // ===== HOGAR Y FAMILIA =====
  { value: 'Home', label: '🏠 Casa (Hogar)', category: 'Hogar' },
  { value: 'Baby', label: '👶 Bebé', category: 'Hogar' },
  { value: 'Users', label: '👥 Personas/Familia', category: 'Hogar' },
  { value: 'Dog', label: '🐕 Perro (Mascotas)', category: 'Hogar' },
  { value: 'Cat', label: '🐈 Gato', category: 'Hogar' },
  { value: 'Bird', label: '🐦 Pájaro', category: 'Hogar' },
  { value: 'Fish', label: '🐟 Pez', category: 'Hogar' },
  
  // ===== EDIFICIOS =====
  { value: 'Building', label: '🏢 Edificio', category: 'Edificios' },
  { value: 'Building2', label: '🏛️ Institución', category: 'Edificios' },
  { value: 'Castle', label: '🏰 Castillo', category: 'Edificios' },
  { value: 'Church', label: '⛪ Iglesia', category: 'Edificios' },
  { value: 'Landmark', label: '🗽 Monumento', category: 'Edificios' },
  
  // ===== NATURALEZA =====
  { value: 'Leaf', label: '🍃 Hoja', category: 'Naturaleza' },
  { value: 'TreePine', label: '🌲 Árbol', category: 'Naturaleza' },
  { value: 'Flower', label: '🌸 Flor', category: 'Naturaleza' },
  { value: 'Sun', label: '☀️ Sol', category: 'Naturaleza' },
  { value: 'Moon', label: '🌙 Luna', category: 'Naturaleza' },
  { value: 'Star', label: '⭐ Estrella', category: 'Naturaleza' },
  { value: 'Droplet', label: '💧 Gota', category: 'Naturaleza' },
  { value: 'Snowflake', label: '❄️ Copo de nieve', category: 'Naturaleza' },
  { value: 'Cloud', label: '☁️ Nube', category: 'Naturaleza' },
  { value: 'Umbrella', label: '☂️ Paraguas', category: 'Naturaleza' },
  { value: 'Flame', label: '🔥 Fuego', category: 'Naturaleza' },
  { value: 'Sunrise', label: '🌅 Amanecer', category: 'Naturaleza' },
  { value: 'Sunset', label: '🌇 Atardecer', category: 'Naturaleza' },
  
  // ===== ROPA Y MODA =====
  { value: 'Shirt', label: '👕 Remera (Indumentaria)', category: 'Moda' },
  { value: 'Scissors', label: '✂️ Tijeras (Peluquería)', category: 'Moda' },
  { value: 'Crown', label: '👑 Corona', category: 'Moda' },
  { value: 'Gem', label: '💎 Gema (Joyería)', category: 'Moda' },
  
  // ===== COMUNICACIÓN =====
  { value: 'Mail', label: '✉️ Email', category: 'Comunicación' },
  { value: 'MessageCircle', label: '💬 Mensaje', category: 'Comunicación' },
  { value: 'Phone', label: '📞 Teléfono', category: 'Comunicación' },
  { value: 'Send', label: '📤 Enviar', category: 'Comunicación' },
  { value: 'Bell', label: '🔔 Campana', category: 'Comunicación' },
  
  // ===== TIEMPO =====
  { value: 'Clock', label: '🕐 Reloj', category: 'Tiempo' },
  { value: 'Calendar', label: '📅 Calendario', category: 'Tiempo' },
  { value: 'CalendarDays', label: '📆 Días', category: 'Tiempo' },
  { value: 'Timer', label: '⏱️ Timer', category: 'Tiempo' },
  { value: 'AlarmClock', label: '⏰ Alarma', category: 'Tiempo' },
  
  // ===== OTROS =====
  { value: 'Gift', label: '🎁 Regalo (General)', category: 'Otros' },
  { value: 'Sparkles', label: '✨ Destellos', category: 'Otros' },
  { value: 'Zap', label: '⚡ Rayo', category: 'Otros' },
  { value: 'Shield', label: '🛡️ Escudo (Seguros)', category: 'Otros' },
  { value: 'BadgeCheck', label: '✅ Verificado', category: 'Otros' },
  { value: 'Key', label: '🔑 Llave', category: 'Otros' },
  { value: 'Lock', label: '🔒 Candado', category: 'Otros' },
  { value: 'PartyPopper', label: '🎉 Fiesta', category: 'Otros' },
  { value: 'Box', label: '📦 Caja', category: 'Otros' },
  { value: 'Rocket', label: '🚀 Cohete', category: 'Otros' },
  { value: 'Dices', label: '🎲 Dados', category: 'Otros' },
  { value: 'Puzzle', label: '🧩 Puzzle', category: 'Otros' },
  { value: 'Flag', label: '🚩 Bandera', category: 'Otros' },
  { value: 'Bookmark', label: '🔖 Marcador', category: 'Otros' },
  { value: 'Clipboard', label: '📋 Portapapeles', category: 'Otros' },
  { value: 'Calculator', label: '🧮 Calculadora', category: 'Otros' },
  { value: 'FileCheck', label: '📄 Documento', category: 'Otros' },
  { value: 'Truck', label: '🚚 Camión', category: 'Otros' },
];

const origenOptions = [
  { value: 'directo', label: 'Convenio Directo del Colegio' },
  { value: 'rueda_turismo', label: 'Rueda de Turismo Social y Sindical' },
];

export default function AdminBeneficiosPage() {
  const [activeTab, setActiveTab] = useState('categorias');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  // Datos
  const [categorias, setCategorias] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  
  // Selección múltiple de prestadores
  const [selectedPrestadores, setSelectedPrestadores] = useState(new Set());
  const [adminBusqueda, setAdminBusqueda] = useState('');
  const [adminFiltroCategoria, setAdminFiltroCategoria] = useState(null);
  
  // Archivo de logo pendiente para nuevos prestadores
  const [pendingLogoFile, setPendingLogoFile] = useState(null);
  
  // Configuración de logos
  const [logoColegio, setLogoColegio] = useState('');
  const [logoRueda, setLogoRueda] = useState('');
  const [savingLogos, setSavingLogos] = useState(false);
  
  // Migración de datos
  const [exportandoDatos, setExportandoDatos] = useState(false);
  const [importandoDatos, setImportandoDatos] = useState(false);
  const [showImportResult, setShowImportResult] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const importFileRef = useRef(null);
  
  // Análisis de importación (nuevo flujo de duplicados)
  const [showAnalisisModal, setShowAnalisisModal] = useState(false);
  const [analisisImport, setAnalisisImport] = useState(null);
  const [datosAImportar, setDatosAImportar] = useState(null);
  const [decisionesDuplicados, setDecisionesDuplicados] = useState({});
  
  // Modales
  const [showCategoriaModal, setShowCategoriaModal] = useState(false);
  const [showPrestadorModal, setShowPrestadorModal] = useState(false);
  const [editingCategoria, setEditingCategoria] = useState(null);
  const [editingPrestador, setEditingPrestador] = useState(null);
  
  // Formulario categoría
  const [categoriaForm, setCategoriaForm] = useState({
    nombre: '',
    descripcion: '',
    icono: 'Gift',
    orden: 0,
    activa: true
  });
  
  // Formulario prestador
  const [prestadorForm, setPrestadorForm] = useState({
    nombre: '',
    categoria_id: '',
    descripcion: '',
    descripcion_larga: '',
    beneficio: '',
    origen: 'directo',
    instrucciones: '',
    logo_url: '',
    direccion: '',
    localidad: '',
    provincia: '',
    telefono: '',
    email: '',
    whatsapp: '',
    sitio_web: '',
    horarios: '',
    precios: '',
    condiciones: '',
    imagenes: [],
    activo: true,
    destacado: false,
    // Nuevos campos de detalle
    descripcion_parrafo1: '',
    imagen_principal: '',
    descripcion_parrafo2: '',
    ubicacion: '',
    info_contacto: '',
    detalles_beneficio: '',
    precios_tarifas: '',
    // Sistema de botones personalizables
    titulo_seccion_botones: 'como_acceder', // default
    boton1_tipo: '',
    boton1_config: {},
    boton2_tipo: '',
    boton2_config: {},
    boton3_tipo: '',
    boton3_config: {},
    // Paquetes turísticos (solo para prestadores de categoría "Paquetes Turísticos")
    paquetes: [],
  });
  
  // Opciones de título para la sección de botones
  const titulosSeccionBotones = [
    { value: 'como_acceder', label: 'Cómo acceder al beneficio' },
    { value: 'links_interes', label: 'Links de interés' },
  ];
  
  // Opciones de tipos de botones
  const tiposBotones = [
    { value: 'ninguno', label: 'Sin botón' },
    { value: 'voucher', label: '🟢 Generar Voucher (PDF con QR)' },
    { value: 'recreo', label: '📋 Presentarte en el Recreo (texto informativo)' },
    { value: 'presentarse_lugar', label: '📍 Presentarte en el lugar (DNI + Credencial + Voucher)' },
    { value: 'codigo_descuento', label: '🏷️ Código de Descuento (para webs)' },
    { value: 'whatsapp', label: '📱 WhatsApp del Prestador' },
    { value: 'email_beneficios', label: '📧 Enviar mail a beneficios@colegiotslomas.org' },
    { value: 'web_prestador', label: '🌐 Ir a la página web del prestador' },
  ];
  
  // Estado para subir imágenes
  const [uploadingGallery, setUploadingGallery] = useState(false);

  useEffect(() => {
    cargarDatos();
    cargarLogos();
  }, []);

  const getToken = () => localStorage.getItem('token');

  const cargarDatos = async (silencioso = false) => {
    if (!silencioso) setLoading(true);
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      const [catRes, prestRes, vouchersRes] = await Promise.all([
        axios.get(`${API_URL}/beneficios/categorias/todas`, { headers }),
        axios.get(`${API_URL}/beneficios/prestadores/todos`, { headers }),
        axios.get(`${API_URL}/beneficios/vouchers`, { headers })
      ]);
      setCategorias(catRes.data);
      setPrestadores(prestRes.data);
      setVouchers(vouchersRes.data);
    } catch (err) {
      setError('Error al cargar datos');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const cargarLogos = async () => {
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      const response = await axios.get(`${API_URL}/beneficios/configuracion/logos`, { headers });
      setLogoColegio(response.data.logo_colegio_url || '');
      setLogoRueda(response.data.logo_rueda_url || '');
    } catch (err) {
      console.error('Error cargando logos:', err);
    }
  };

  const subirLogoColegio = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    if (file.size > 500 * 1024) {
      setError('La imagen no debe superar 500KB');
      return;
    }
    
    setSavingLogos(true);
    const formData = new FormData();
    formData.append('logo', file);
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      const res = await axios.post(
        `${API_URL}/beneficios/configuracion/logos/colegio`,
        formData,
        { headers }
      );
      setLogoColegio(res.data.logo_url);
      setSuccess('Logo del Colegio actualizado');
    } catch (err) {
      setError('Error al subir el logo');
    } finally {
      setSavingLogos(false);
      e.target.value = '';
    }
  };

  const subirLogoRueda = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    if (file.size > 500 * 1024) {
      setError('La imagen no debe superar 500KB');
      return;
    }
    
    setSavingLogos(true);
    const formData = new FormData();
    formData.append('logo', file);
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      const res = await axios.post(
        `${API_URL}/beneficios/configuracion/logos/rueda`,
        formData,
        { headers }
      );
      setLogoRueda(res.data.logo_url);
      setSuccess('Logo de la Rueda actualizado');
    } catch (err) {
      setError('Error al subir el logo');
    } finally {
      setSavingLogos(false);
      e.target.value = '';
    }
  };

  // === MIGRACIÓN DE DATOS ===
  
  const handleExportarDatos = async () => {
    setExportandoDatos(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/beneficios/admin/exportar-datos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Descargar como JSON
      const dataStr = JSON.stringify(response.data, null, 2);
      const blob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `beneficios_export_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      setSuccess(`Exportados ${response.data.total_categorias} categorías y ${response.data.total_prestadores} prestadores`);
    } catch (err) {
      console.error('Error exportando datos:', err);
      setError('Error al exportar los datos');
    } finally {
      setExportandoDatos(false);
    }
  };

  const handleImportarDatos = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImportandoDatos(true);
    try {
      const text = await file.text();
      const data = JSON.parse(text);
      
      if (!data.categorias && !data.prestadores) {
        throw new Error('El archivo no tiene la estructura correcta');
      }
      
      // Guardar datos para importar después
      setDatosAImportar(data);
      
      // Primero analizar para detectar duplicados
      const token = localStorage.getItem('token');
      const analisisResponse = await axios.post(`${API_URL}/beneficios/admin/analizar-importacion`, {
        categorias: data.categorias || [],
        prestadores: data.prestadores || []
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setAnalisisImport(analisisResponse.data);
      
      // Si hay duplicados, mostrar modal de análisis para que el usuario decida
      if (analisisResponse.data.resumen.prestadores_duplicados > 0) {
        // Inicializar decisiones como "omitir" por defecto
        const decisiones = {};
        analisisResponse.data.prestadores.duplicados.forEach(dup => {
          decisiones[dup.indice] = 'omitir';
        });
        setDecisionesDuplicados(decisiones);
        setShowAnalisisModal(true);
      } else {
        // No hay duplicados, importar directamente
        await ejecutarImportacion(data, {});
      }
      
    } catch (err) {
      console.error('Error analizando datos:', err);
      setImportResult({
        success: false,
        mensaje: err.message || 'Error al analizar los datos'
      });
      setShowImportResult(true);
    } finally {
      setImportandoDatos(false);
      if (importFileRef.current) {
        importFileRef.current.value = '';
      }
    }
  };

  const ejecutarImportacion = async (data, decisiones) => {
    setImportandoDatos(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/beneficios/admin/importar-datos`, {
        categorias: data.categorias || [],
        prestadores: data.prestadores || [],
        logos: data.logos || [],
        decisiones_duplicados: decisiones
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setImportResult(response.data);
      setShowImportResult(true);
      setShowAnalisisModal(false);
      
      // Recargar datos
      cargarDatos();
    } catch (err) {
      console.error('Error importando datos:', err);
      setImportResult({
        success: false,
        mensaje: err.message || 'Error al importar los datos'
      });
      setShowImportResult(true);
    } finally {
      setImportandoDatos(false);
    }
  };

  const handleConfirmarImportacion = () => {
    if (datosAImportar) {
      ejecutarImportacion(datosAImportar, decisionesDuplicados);
    }
  };

  const handleDecisionDuplicado = (indice, decision) => {
    setDecisionesDuplicados(prev => ({
      ...prev,
      [indice]: decision
    }));
  };

  const handleAplicarDecisionATodos = (decision) => {
    if (!analisisImport) return;
    const nuevasDecisiones = {};
    analisisImport.prestadores.duplicados.forEach(dup => {
      nuevasDecisiones[dup.indice] = decision;
    });
    setDecisionesDuplicados(nuevasDecisiones);
  };

  // === CATEGORÍAS ===
  
  const abrirCategoriaModal = (categoria = null) => {
    if (categoria) {
      setEditingCategoria(categoria);
      setCategoriaForm({
        nombre: categoria.nombre || '',
        descripcion: categoria.descripcion || '',
        icono: categoria.icono || 'Gift',
        orden: categoria.orden || 0,
        activa: categoria.activa !== false
      });
    } else {
      setEditingCategoria(null);
      setCategoriaForm({
        nombre: '',
        descripcion: '',
        icono: 'Gift',
        orden: categorias.length + 1,
        activa: true
      });
    }
    setShowCategoriaModal(true);
  };

  const guardarCategoria = async () => {
    if (!categoriaForm.nombre.trim()) {
      setError('El nombre es obligatorio');
      return;
    }
    
    setSaving(true);
    setError(null);
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      
      if (editingCategoria) {
        await axios.put(
          `${API_URL}/beneficios/categorias/${editingCategoria.id}`,
          categoriaForm,
          { headers }
        );
        setSuccess('Categoría actualizada');
      } else {
        await axios.post(
          `${API_URL}/beneficios/categorias`,
          categoriaForm,
          { headers }
        );
        setSuccess('Categoría creada');
      }
      
      setShowCategoriaModal(false);
      cargarDatos();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const eliminarCategoria = async (id) => {
    if (!window.confirm('¿Eliminar esta categoría?')) return;
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      await axios.delete(`${API_URL}/beneficios/categorias/${id}`, { headers });
      setSuccess('Categoría eliminada');
      cargarDatos();
    } catch (err) {
      setError('Error al eliminar');
    }
  };

  // === PRESTADORES ===
  
  const abrirPrestadorModal = (prestador = null) => {
    setPendingLogoFile(null); // Limpiar archivo pendiente
    if (prestador) {
      setEditingPrestador(prestador);
      setPrestadorForm({
        nombre: prestador.nombre || '',
        categoria_id: prestador.categoria_id || '',
        descripcion: prestador.descripcion || '',
        descripcion_larga: prestador.descripcion_larga || '',
        beneficio: prestador.beneficio || '',
        origen: prestador.origen || 'directo',
        instrucciones: prestador.instrucciones || '',
        logo_url: prestador.logo_url || '',
        direccion: prestador.direccion || '',
        localidad: prestador.localidad || '',
        provincia: prestador.provincia || '',
        telefono: prestador.telefono || '',
        email: prestador.email || '',
        whatsapp: prestador.whatsapp || '',
        sitio_web: prestador.sitio_web || '',
        horarios: prestador.horarios || '',
        precios: prestador.precios || '',
        condiciones: prestador.condiciones || '',
        imagenes: prestador.imagenes || [],
        activo: prestador.activo !== false,
        destacado: !!prestador.destacado,
        // Nuevos campos
        descripcion_parrafo1: prestador.descripcion_parrafo1 || '',
        imagen_principal: prestador.imagen_principal || '',
        descripcion_parrafo2: prestador.descripcion_parrafo2 || '',
        ubicacion: prestador.ubicacion || '',
        info_contacto: prestador.info_contacto || '',
        detalles_beneficio: prestador.detalles_beneficio || '',
        precios_tarifas: prestador.precios_tarifas || '',
        // Botones personalizables
        titulo_seccion_botones: prestador.titulo_seccion_botones || 'como_acceder',
        boton1_tipo: prestador.boton1_tipo || 'ninguno',
        boton1_config: prestador.boton1_config || {},
        boton2_tipo: prestador.boton2_tipo || 'ninguno',
        boton2_config: prestador.boton2_config || {},
        boton3_tipo: prestador.boton3_tipo || 'ninguno',
        boton3_config: prestador.boton3_config || {},
        paquetes: prestador.paquetes || [],
      });
    } else {
      setEditingPrestador(null);
      setPrestadorForm({
        nombre: '',
        categoria_id: categorias[0]?.id || '',
        descripcion: '',
        descripcion_larga: '',
        beneficio: '',
        origen: 'directo',
        instrucciones: '',
        logo_url: '',
        direccion: '',
        localidad: '',
        provincia: '',
        telefono: '',
        email: '',
        whatsapp: '',
        sitio_web: '',
        horarios: '',
        precios: '',
        condiciones: '',
        imagenes: [],
        activo: true,
        destacado: false,
        // Nuevos campos
        descripcion_parrafo1: '',
        imagen_principal: '',
        descripcion_parrafo2: '',
        ubicacion: '',
        info_contacto: '',
        detalles_beneficio: '',
        precios_tarifas: '',
        // Botones
        titulo_seccion_botones: 'como_acceder',
        boton1_tipo: 'ninguno',
        boton1_config: {},
        boton2_tipo: 'ninguno',
        boton2_config: {},
        boton3_tipo: 'ninguno',
        boton3_config: {},
        paquetes: [],
      });
    }
    setShowPrestadorModal(true);
  };

  const guardarPrestador = async () => {
    if (!prestadorForm.nombre.trim() || !prestadorForm.categoria_id) {
      setError('Nombre y categoría son obligatorios');
      return;
    }
    
    if (saving) {
      console.log('Ya se está guardando, ignorando click');
      return;
    }
    
    setSaving(true);
    setError(null);
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      
      // Convertir 'ninguno' a cadena vacía para los tipos de botones
      const dataToSave = {
        ...prestadorForm,
        boton1_tipo: prestadorForm.boton1_tipo === 'ninguno' ? '' : prestadorForm.boton1_tipo,
        boton2_tipo: prestadorForm.boton2_tipo === 'ninguno' ? '' : prestadorForm.boton2_tipo,
        boton3_tipo: prestadorForm.boton3_tipo === 'ninguno' ? '' : prestadorForm.boton3_tipo,
      };
      
      console.log('Guardando prestador...', editingPrestador ? 'UPDATE' : 'CREATE');
      
      if (editingPrestador) {
        await axios.put(
          `${API_URL}/beneficios/prestadores/${editingPrestador.id}`,
          dataToSave,
          { headers, timeout: 30000 }
        );
        setSuccess('Prestador actualizado');
      } else {
        // Crear nuevo prestador
        // Si hay logo en base64, no lo enviamos (el backend no lo acepta)
        const dataWithoutBase64Logo = { ...dataToSave };
        if (dataWithoutBase64Logo.logo_url?.startsWith('data:')) {
          dataWithoutBase64Logo.logo_url = '';
        }
        
        const response = await axios.post(
          `${API_URL}/beneficios/prestadores`,
          dataWithoutBase64Logo,
          { headers, timeout: 30000 }
        );
        
        // Si hay un archivo de logo pendiente, subirlo ahora
        if (pendingLogoFile && response.data?.id) {
          const formData = new FormData();
          formData.append('logo', pendingLogoFile);
          try {
            await axios.post(
              `${API_URL}/beneficios/prestadores/${response.data.id}/logo`,
              formData,
              { headers }
            );
          } catch (logoErr) {
            console.error('Error subiendo logo:', logoErr);
            // No fallar toda la operación, el prestador ya se creó
          }
        }
        
        setPendingLogoFile(null);
        setSuccess('Prestador creado');
      }
      
      console.log('Guardado exitoso');
      setShowPrestadorModal(false);
      cargarDatos();
    } catch (err) {
      console.error('Error al guardar:', err);
      setError(err.response?.data?.detail || err.message || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const eliminarPrestador = async (id) => {
    if (!window.confirm('¿Eliminar este prestador?')) return;
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      await axios.delete(`${API_URL}/beneficios/prestadores/${id}`, { headers });
      setSuccess('Prestador eliminado');
      setSelectedPrestadores(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      cargarDatos();
    } catch (err) {
      setError('Error al eliminar');
    }
  };

  // Funciones de selección múltiple
  const toggleSelectPrestador = (id) => {
    setSelectedPrestadores(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const toggleSelectAll = () => {
    // Toggle selección solo sobre los prestadores actualmente filtrados
    const idsFiltrados = prestadoresAdminFiltrados.map(p => p.id);
    const seleccionadosVisibles = idsFiltrados.filter(id => selectedPrestadores.has(id)).length;
    if (seleccionadosVisibles === idsFiltrados.length && idsFiltrados.length > 0) {
      // Todos los visibles están seleccionados → los quitamos
      setSelectedPrestadores(prev => {
        const next = new Set(prev);
        idsFiltrados.forEach(id => next.delete(id));
        return next;
      });
    } else {
      // Agregamos todos los visibles
      setSelectedPrestadores(prev => {
        const next = new Set(prev);
        idsFiltrados.forEach(id => next.add(id));
        return next;
      });
    }
  };

  // Prestadores filtrados por búsqueda + categoría (para vista admin)
  const prestadoresAdminFiltrados = React.useMemo(() => {
    const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const termino = norm(adminBusqueda.trim());
    return prestadores.filter(p => {
      if (adminFiltroCategoria && p.categoria_id !== adminFiltroCategoria) return false;
      if (!termino) return true;
      // Búsqueda en paquetes[] (título / subtítulo / descripción larga)
      const paquetesMatch = Array.isArray(p.paquetes) && p.paquetes.some(paq =>
        norm(paq?.titulo).includes(termino) ||
        norm(paq?.descripcion_corta).includes(termino) ||
        norm(paq?.descripcion_larga).includes(termino)
      );
      return (
        norm(p.nombre).includes(termino) ||
        norm(p.descripcion).includes(termino) ||
        norm(p.beneficio).includes(termino) ||
        norm(p.categoria_nombre).includes(termino) ||
        norm(p.localidad).includes(termino) ||
        norm(p.provincia).includes(termino) ||
        paquetesMatch
      );
    });
  }, [prestadores, adminBusqueda, adminFiltroCategoria]);

  const eliminarSeleccionados = async () => {
    if (selectedPrestadores.size === 0) return;
    
    if (!window.confirm(`¿Eliminar ${selectedPrestadores.size} prestadores seleccionados? Esta acción no se puede deshacer.`)) return;
    
    setSaving(true);
    const headers = { Authorization: `Bearer ${getToken()}` };
    let eliminados = 0;
    let errores = 0;
    
    for (const id of selectedPrestadores) {
      try {
        await axios.delete(`${API_URL}/beneficios/prestadores/${id}`, { headers });
        eliminados++;
      } catch (err) {
        errores++;
        console.error(`Error eliminando ${id}:`, err);
      }
    }
    
    setSaving(false);
    setSelectedPrestadores(new Set());
    
    if (errores > 0) {
      setSuccess(`${eliminados} prestadores eliminados. ${errores} errores.`);
    } else {
      setSuccess(`${eliminados} prestadores eliminados`);
    }
    
    cargarDatos();
  };

  // === VOUCHERS ===
  const anularVoucher = async (voucherId) => {
    if (!window.confirm('¿Anular este voucher? Esta acción no se puede deshacer.')) return;
    
    try {
      const headers = { Authorization: `Bearer ${getToken()}` };
      await axios.put(`${API_URL}/beneficios/vouchers/${voucherId}/anular`, {}, { headers });
      setSuccess('Voucher anulado');
      cargarDatos();
    } catch (err) {
      setError('Error al anular voucher');
    }
  };

  // Limpiar mensajes
  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        setSuccess(null);
        setError(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, error]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-green-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      {/* Header con estilo del portal público */}
      <div className="relative overflow-hidden rounded-3xl shadow-lg mb-2">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-600 via-purple-700 to-indigo-800" />
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/10 blur-2xl" />
        <div className="absolute -bottom-20 -left-10 w-56 h-56 rounded-full bg-fuchsia-400/20 blur-2xl" />
        <div className="relative flex items-center justify-between p-6 sm:p-8 text-white">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-white/95 rounded-2xl shadow-lg flex items-center justify-center">
              <Gift className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-3 py-0.5 mb-1">
                <span className="text-[10px] font-semibold uppercase tracking-widest">Panel Admin</span>
              </div>
              <h1 className="text-2xl sm:text-3xl font-bold leading-tight">Guía de Beneficios TS+</h1>
              <p className="text-white/80 text-sm">Administrá categorías, prestadores, paquetes y vouchers</p>
            </div>
          </div>
          <div className="hidden md:block">
            <a
              href="/beneficios"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white/95 hover:bg-white text-purple-800 font-semibold px-4 py-2.5 rounded-xl shadow-md transition-colors"
              data-testid="admin-ver-portal-btn"
            >
              <Eye className="w-4 h-4" />
              Ver portal público
            </a>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      {(() => {
        const totalPrestadores = prestadores.length;
        const destacadosCount = prestadores.filter(p => p.destacado).length;
        const conPaquetes = prestadores.filter(p => Array.isArray(p.paquetes) && p.paquetes.length > 0).length;
        const totalPaquetes = prestadores.reduce((acc, p) => acc + (Array.isArray(p.paquetes) ? p.paquetes.length : 0), 0);
        const categoriasActivas = categorias.filter(c => c.activa).length;
        return (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="bg-white rounded-2xl border border-gray-200 p-4 flex items-center gap-3 shadow-sm">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center shadow-sm">
                <Building2 className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Prestadores</p>
                <p className="text-2xl font-bold text-gray-900 leading-none">{totalPrestadores}</p>
              </div>
            </div>
            <div className="bg-white rounded-2xl border border-gray-200 p-4 flex items-center gap-3 shadow-sm">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-sm">
                <Star className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Destacados</p>
                <p className="text-2xl font-bold text-gray-900 leading-none">{destacadosCount}</p>
              </div>
            </div>
            <div className="bg-white rounded-2xl border border-gray-200 p-4 flex items-center gap-3 shadow-sm">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center shadow-sm">
                <Package className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Con paquetes</p>
                <p className="text-2xl font-bold text-gray-900 leading-none">
                  {conPaquetes}
                  <span className="text-sm text-gray-500 font-normal ml-1">/ {totalPaquetes} total</span>
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl border border-gray-200 p-4 flex items-center gap-3 shadow-sm">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center shadow-sm">
                <FolderOpen className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wider">Categorías</p>
                <p className="text-2xl font-bold text-gray-900 leading-none">
                  {categoriasActivas}
                  <span className="text-sm text-gray-500 font-normal ml-1">/ {categorias.length}</span>
                </p>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Mensajes */}
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700">
          <AlertCircle className="w-4 h-4" />
          {error}
        </div>
      )}
      {success && (
        <div className="p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2 text-green-700">
          <CheckCircle className="w-4 h-4" />
          {success}
        </div>
      )}

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <div className="scroll-x-safe pb-1 -mx-4 px-4 md:mx-0 md:px-0">
          <TabsList className="inline-flex min-w-max">
            <TabsTrigger value="categorias" className="flex items-center gap-2 whitespace-nowrap">
              <FolderOpen className="w-4 h-4" />
              Categorías ({categorias.length})
            </TabsTrigger>
            <TabsTrigger value="prestadores" className="flex items-center gap-2 whitespace-nowrap">
              <Building2 className="w-4 h-4" />
              Prestadores ({prestadores.length})
            </TabsTrigger>
            <TabsTrigger value="vouchers" className="flex items-center gap-2 whitespace-nowrap">
              <FileText className="w-4 h-4" />
              Vouchers Emitidos
            </TabsTrigger>
            <TabsTrigger value="rueda" className="flex items-center gap-2 whitespace-nowrap" data-testid="tab-rueda-import">
              <Bus className="w-4 h-4" />
              Importar de la Rueda
            </TabsTrigger>
            <TabsTrigger value="configuracion" className="flex items-center gap-2 whitespace-nowrap">
              <Settings className="w-4 h-4" />
              Configuración
            </TabsTrigger>
          </TabsList>
        </div>

        {/* Tab Categorías */}
        <TabsContent value="categorias">
          <Card className="rounded-2xl shadow-sm border-gray-200">
            <CardHeader className="flex flex-row items-center justify-between border-b border-gray-100">
              <div>
                <CardTitle className="text-xl">Categorías de Beneficios</CardTitle>
                <p className="text-sm text-gray-500 mt-1">
                  {categorias.length} categorías · agrupan los prestadores por rubro
                </p>
              </div>
              <Button
                onClick={() => abrirCategoriaModal()}
                className="bg-purple-600 hover:bg-purple-700 rounded-xl"
                data-testid="nueva-categoria-btn"
              >
                <Plus className="w-4 h-4 mr-2" />
                Nueva Categoría
              </Button>
            </CardHeader>
            <CardContent className="pt-6">
              {categorias.length === 0 ? (
                <p className="text-gray-500 text-center py-8">No hay categorías</p>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {categorias.map((cat) => {
                    const IconComp = iconMap[cat.icono] || Gift;
                    const prestadoresEnCat = prestadores.filter(p => p.categoria_id === cat.id).length;
                    return (
                      <div
                        key={cat.id}
                        className={`group relative rounded-2xl border-2 p-4 transition-all hover:shadow-md ${
                          cat.activa
                            ? 'border-gray-200 bg-white hover:border-purple-300'
                            : 'border-gray-200 bg-gray-50 opacity-70'
                        }`}
                        data-testid={`admin-cat-card-${cat.id}`}
                      >
                        <div className="flex items-start gap-3">
                          <div className={`w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0 ${
                            cat.activa
                              ? 'bg-gradient-to-br from-purple-500 to-purple-700 text-white shadow-md'
                              : 'bg-gray-200 text-gray-400'
                          }`}>
                            <IconComp className="w-7 h-7" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1 flex-wrap">
                              <p className="font-bold text-gray-900 leading-tight truncate">{cat.nombre}</p>
                              <Badge className={cat.activa
                                ? 'bg-emerald-100 text-emerald-700 border-0 text-[10px]'
                                : 'bg-gray-200 text-gray-600 border-0 text-[10px]'
                              }>
                                {cat.activa ? 'Activa' : 'Inactiva'}
                              </Badge>
                            </div>
                            {cat.descripcion && (
                              <p className="text-xs text-gray-500 line-clamp-2 mb-2">{cat.descripcion}</p>
                            )}
                            <p className="text-xs text-purple-700 font-semibold">
                              {prestadoresEnCat} {prestadoresEnCat === 1 ? 'prestador' : 'prestadores'}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-1 mt-3 pt-3 border-t border-gray-100">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => abrirCategoriaModal(cat)}
                            className="flex-1"
                            data-testid={`admin-cat-editar-${cat.id}`}
                          >
                            <Pencil className="w-4 h-4 mr-1" />
                            Editar
                          </Button>
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => eliminarCategoria(cat.id)}
                            className="text-red-600 hover:text-red-700 hover:bg-red-50"
                            data-testid={`admin-cat-eliminar-${cat.id}`}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab Prestadores */}
        <TabsContent value="prestadores">
          <Card className="rounded-2xl shadow-sm border-gray-200">
            <CardHeader className="border-b border-gray-100 space-y-4">
              <div className="flex flex-row items-center justify-between flex-wrap gap-2">
                <div>
                  <CardTitle className="text-xl">Prestadores / Convenios</CardTitle>
                  <p className="text-sm text-gray-500 mt-1">
                    {prestadores.length} prestadores cargados
                  </p>
                </div>
                <div className="flex gap-2 items-center">
                  {selectedPrestadores.size > 0 && (
                    <Button
                      onClick={eliminarSeleccionados}
                      variant="destructive"
                      disabled={saving}
                      className="rounded-xl"
                      data-testid="admin-eliminar-seleccionados-btn"
                    >
                      <Trash2 className="w-4 h-4 mr-2" />
                      Eliminar ({selectedPrestadores.size})
                    </Button>
                  )}
                  <Button
                    onClick={() => abrirPrestadorModal()}
                    className="bg-purple-600 hover:bg-purple-700 rounded-xl"
                    data-testid="admin-nuevo-prestador-btn"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Nuevo Prestador
                  </Button>
                </div>
              </div>

              {/* Toolbar: búsqueda + filtros */}
              <div className="flex items-center gap-3 flex-wrap">
                <div className="relative flex-1 min-w-[220px] max-w-md">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                  <Input
                    type="text"
                    placeholder="Buscar prestador por nombre, categoría o beneficio…"
                    value={adminBusqueda}
                    onChange={(e) => setAdminBusqueda(e.target.value)}
                    className="pl-9 rounded-xl"
                    data-testid="admin-prestadores-search"
                  />
                </div>
                <Select value={adminFiltroCategoria || 'todas'} onValueChange={(v) => setAdminFiltroCategoria(v === 'todas' ? null : v)}>
                  <SelectTrigger className="w-[200px] rounded-xl" data-testid="admin-filtro-categoria">
                    <SelectValue placeholder="Filtrar por categoría" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="todas">Todas las categorías</SelectItem>
                    {categorias.map((cat) => (
                      <SelectItem key={cat.id} value={cat.id}>{cat.nombre}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {(adminBusqueda || adminFiltroCategoria) && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => { setAdminBusqueda(''); setAdminFiltroCategoria(null); }}
                    className="text-purple-600 hover:text-purple-700"
                  >
                    Limpiar filtros
                  </Button>
                )}
              </div>

              {/* Select all */}
              {prestadoresAdminFiltrados.length > 0 && (
                <div className="flex items-center gap-2 pb-1">
                  <input
                    type="checkbox"
                    checked={selectedPrestadores.size === prestadoresAdminFiltrados.length && prestadoresAdminFiltrados.length > 0}
                    onChange={toggleSelectAll}
                    className="w-4 h-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
                  />
                  <span className="text-sm text-gray-600">
                    {selectedPrestadores.size === prestadoresAdminFiltrados.length && prestadoresAdminFiltrados.length > 0
                      ? 'Deseleccionar todos'
                      : `Seleccionar todos (${prestadoresAdminFiltrados.length})`}
                  </span>
                  {selectedPrestadores.size > 0 && (
                    <Badge variant="secondary" className="ml-2">
                      {selectedPrestadores.size} seleccionados
                    </Badge>
                  )}
                </div>
              )}
            </CardHeader>
            <CardContent className="pt-6">
              {prestadoresAdminFiltrados.length === 0 ? (
                <div className="text-center py-16">
                  <Building2 className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                  <p className="text-gray-500 font-medium">
                    {adminBusqueda || adminFiltroCategoria ? 'Sin resultados para los filtros aplicados' : 'No hay prestadores cargados'}
                  </p>
                  {(adminBusqueda || adminFiltroCategoria) && (
                    <Button
                      variant="link"
                      onClick={() => { setAdminBusqueda(''); setAdminFiltroCategoria(null); }}
                      className="mt-2 text-purple-600"
                    >
                      Limpiar filtros
                    </Button>
                  )}
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {prestadoresAdminFiltrados.map((prest) => {
                    const CatIcon = iconMap[categorias.find(c => c.id === prest.categoria_id)?.icono] || Gift;
                    const heroImg = prest.imagen_principal || (prest.imagenes && prest.imagenes[0]);
                    const seleccionado = selectedPrestadores.has(prest.id);
                    const paquetesCount = Array.isArray(prest.paquetes) ? prest.paquetes.length : 0;
                    return (
                      <div
                        key={prest.id}
                        className={`group relative rounded-2xl border-2 overflow-hidden transition-all hover:shadow-md ${
                          seleccionado
                            ? 'border-purple-500 ring-2 ring-purple-200'
                            : 'border-gray-200 bg-white hover:border-purple-300'
                        }`}
                        data-testid={`admin-prest-card-${prest.id}`}
                      >
                        {/* Checkbox flotante */}
                        <input
                          type="checkbox"
                          checked={seleccionado}
                          onChange={() => toggleSelectPrestador(prest.id)}
                          className="absolute top-3 left-3 w-5 h-5 rounded border-gray-300 text-purple-600 focus:ring-purple-500 z-20 shadow-lg cursor-pointer"
                          data-testid={`admin-prest-check-${prest.id}`}
                        />

                        {/* Hero image + logo circular */}
                        <div className="relative aspect-[16/9] bg-gradient-to-br from-purple-100 via-purple-50 to-white overflow-hidden">
                          {heroImg ? (
                            <img
                              src={heroImg}
                              alt={prest.nombre}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center">
                              <CatIcon className="w-14 h-14 text-purple-300" />
                            </div>
                          )}
                          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

                          {/* Badges arriba a la derecha */}
                          <div className="absolute top-2 right-2 flex flex-col gap-1 items-end">
                            {!prest.activo && (
                              <Badge className="bg-gray-800 text-white border-0 text-[10px]">Inactivo</Badge>
                            )}
                            {prest.destacado && (
                              <Badge className="bg-amber-500 text-white border-0 text-[10px] shadow">
                                <Star className="w-3 h-3 mr-1" />
                                Destacado
                              </Badge>
                            )}
                            {prest.origen === 'rueda_turismo' && (
                              <Badge className="bg-sky-600 text-white border-0 text-[10px] shadow">Rueda</Badge>
                            )}
                          </div>

                          {/* Logo circular flotante */}
                          <div className="absolute inset-x-0 bottom-0 flex justify-center translate-y-1/2 z-10">
                            <div className="w-14 h-14 bg-white rounded-2xl shadow-md ring-4 ring-white flex items-center justify-center overflow-hidden">
                              {prest.logo_url ? (
                                <img
                                  src={prest.logo_url}
                                  alt={prest.nombre}
                                  className="max-w-full max-h-full object-contain p-1"
                                />
                              ) : (
                                <CatIcon className="w-7 h-7 text-purple-400" />
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Info */}
                        <div className="pt-9 px-4 pb-3 text-center">
                          <p className="font-bold text-gray-900 text-sm uppercase tracking-tight line-clamp-1">
                            {prest.nombre}
                          </p>
                          <Badge variant="outline" className="text-[10px] mt-1 border-purple-200 text-purple-700">
                            <CatIcon className="w-3 h-3 mr-1" />
                            {prest.categoria_nombre}
                          </Badge>
                          {prest.beneficio && (
                            <p className="text-xs text-emerald-700 font-medium mt-2 line-clamp-2 min-h-[2rem]">
                              {prest.beneficio}
                            </p>
                          )}
                          {paquetesCount > 0 && (
                            <div className="mt-2 inline-flex items-center gap-1 text-[10px] font-semibold text-sky-800 bg-sky-100 border border-sky-200 px-2 py-0.5 rounded-full">
                              <Package className="w-3 h-3" />
                              {paquetesCount} {paquetesCount === 1 ? 'paquete' : 'paquetes'}
                            </div>
                          )}
                        </div>

                        {/* Barra de acciones */}
                        <div className="flex items-center border-t border-gray-100 divide-x divide-gray-100">
                          <button
                            onClick={() => window.open(`/beneficios/prestador/${prest.id}`, '_blank')}
                            className="flex-1 py-2.5 text-xs font-medium text-gray-600 hover:bg-purple-50 hover:text-purple-700 flex items-center justify-center gap-1"
                            title="Ver en portal público"
                            data-testid={`admin-prest-ver-${prest.id}`}
                          >
                            <Eye className="w-3.5 h-3.5" />
                            Ver
                          </button>
                          <button
                            onClick={() => abrirPrestadorModal(prest)}
                            className="flex-1 py-2.5 text-xs font-medium text-purple-700 hover:bg-purple-50 flex items-center justify-center gap-1"
                            data-testid={`admin-prest-editar-${prest.id}`}
                          >
                            <Pencil className="w-3.5 h-3.5" />
                            Editar
                          </button>
                          <button
                            onClick={() => eliminarPrestador(prest.id)}
                            className="flex-1 py-2.5 text-xs font-medium text-red-600 hover:bg-red-50 flex items-center justify-center gap-1"
                            data-testid={`admin-prest-eliminar-${prest.id}`}
                          >
                            <Trash2 className="w-3.5 h-3.5" />
                            Eliminar
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab Vouchers */}
        <TabsContent value="vouchers">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                <span>Vouchers Emitidos</span>
                <Badge variant="outline">{vouchers.length} vouchers</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {vouchers.length === 0 ? (
                <p className="text-gray-500 text-center py-8">
                  No hay vouchers emitidos todavía
                </p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b bg-gray-50">
                        <th className="text-left p-3 font-semibold">Código</th>
                        <th className="text-left p-3 font-semibold">Matriculado</th>
                        <th className="text-left p-3 font-semibold">Matrícula</th>
                        <th className="text-left p-3 font-semibold">Prestador</th>
                        <th className="text-left p-3 font-semibold">Origen</th>
                        <th className="text-left p-3 font-semibold">Fecha Emisión</th>
                        <th className="text-left p-3 font-semibold">Vencimiento</th>
                        <th className="text-left p-3 font-semibold">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vouchers.map((voucher) => (
                        <tr key={voucher.id} className="border-b hover:bg-gray-50">
                          <td className="p-3 font-mono font-semibold">{voucher.id}</td>
                          <td className="p-3">{voucher.nombre}</td>
                          <td className="p-3">{voucher.matricula}</td>
                          <td className="p-3">{voucher.prestador_nombre || '-'}</td>
                          <td className="p-3">
                            <Badge 
                              className={voucher.origen === 'rueda_turismo' 
                                ? 'bg-purple-100 text-purple-700' 
                                : 'bg-green-100 text-green-700'}
                            >
                              {voucher.origen === 'rueda_turismo' ? 'Rueda' : 'Directo'}
                            </Badge>
                          </td>
                          <td className="p-3">
                            {new Date(voucher.fecha_emision).toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
                            })}
                          </td>
                          <td className="p-3">
                            {new Date(voucher.fecha_vencimiento).toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires', day: '2-digit', month: '2-digit', year: 'numeric'
                            })}
                          </td>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              {voucher.valido && new Date(voucher.fecha_vencimiento) > new Date() ? (
                                <>
                                  <Badge className="bg-green-100 text-green-700">Válido</Badge>
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => anularVoucher(voucher.id)}
                                    className="text-red-600 hover:text-red-700 hover:bg-red-50 h-7 px-2"
                                  >
                                    <X className="w-3 h-3 mr-1" />
                                    Anular
                                  </Button>
                                </>
                              ) : !voucher.valido ? (
                                <Badge className="bg-gray-100 text-gray-700">Anulado</Badge>
                              ) : (
                                <Badge className="bg-red-100 text-red-700">Vencido</Badge>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        {/* Tab Configuración */}
        <TabsContent value="rueda">
          <RuedaImportacionTab categorias={categorias} onPublicado={() => cargarDatos(true)} />
        </TabsContent>

        <TabsContent value="configuracion">
          <Card>
            <CardHeader>
              <CardTitle>Configuración de Logos para Vouchers</CardTitle>
            </CardHeader>
            <CardContent className="space-y-8">
              <p className="text-sm text-gray-500">
                Estos logos aparecerán en los vouchers generados por los matriculados. 
                El logo del Colegio aparece en todos los vouchers, mientras que el logo de la 
                Rueda de Turismo Social aparece solo en los vouchers de prestadores de ese convenio.
              </p>
              
              {/* Logo del Colegio */}
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-4">Logo del Colegio</h3>
                <div className="flex items-center gap-6">
                  {logoColegio ? (
                    <div className="relative">
                      <img 
                        src={logoColegio} 
                        alt="Logo del Colegio" 
                        className="w-24 h-24 object-contain border rounded-lg p-2"
                      />
                      <button
                        type="button"
                        onClick={() => setLogoColegio('')}
                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  ) : (
                    <div className="w-24 h-24 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center">
                      <Image className="w-8 h-8 text-gray-400" />
                    </div>
                  )}
                  
                  <div className="flex-1">
                    <input
                      type="file"
                      id="logo-colegio-upload"
                      accept="image/*"
                      className="hidden"
                      onChange={subirLogoColegio}
                      disabled={savingLogos}
                    />
                    <label htmlFor="logo-colegio-upload">
                      <Button type="button" variant="outline" disabled={savingLogos} className="cursor-pointer" asChild>
                        <span>
                          {savingLogos ? (
                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                          ) : (
                            <Upload className="w-4 h-4 mr-2" />
                          )}
                          {logoColegio ? 'Cambiar Logo' : 'Subir Logo'}
                        </span>
                      </Button>
                    </label>
                    <p className="text-xs text-gray-500 mt-2">
                      Este logo aparecerá en TODOS los vouchers generados.
                    </p>
                    <p className="text-xs text-gray-400">PNG, JPG o WEBP. Máximo 500KB.</p>
                  </div>
                </div>
              </div>
              
              {/* Logo de la Rueda de Turismo */}
              <div className="border rounded-lg p-4 border-purple-200 bg-purple-50/30">
                <h3 className="font-semibold mb-4 flex items-center gap-2">
                  <span>Logo de la Rueda de Turismo Social</span>
                  <Badge className="bg-purple-100 text-purple-700">Convenio especial</Badge>
                </h3>
                <div className="flex items-center gap-6">
                  {logoRueda ? (
                    <div className="relative">
                      <img 
                        src={logoRueda} 
                        alt="Logo Rueda de Turismo" 
                        className="w-24 h-24 object-contain border rounded-lg p-2 bg-white"
                      />
                      <button
                        type="button"
                        onClick={() => setLogoRueda('')}
                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  ) : (
                    <div className="w-24 h-24 bg-white border-2 border-dashed border-purple-300 rounded-lg flex items-center justify-center">
                      <Image className="w-8 h-8 text-purple-400" />
                    </div>
                  )}
                  
                  <div className="flex-1">
                    <input
                      type="file"
                      id="logo-rueda-upload"
                      accept="image/*"
                      className="hidden"
                      onChange={subirLogoRueda}
                      disabled={savingLogos}
                    />
                    <label htmlFor="logo-rueda-upload">
                      <Button type="button" variant="outline" disabled={savingLogos} className="cursor-pointer" asChild>
                        <span>
                          {savingLogos ? (
                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                          ) : (
                            <Upload className="w-4 h-4 mr-2" />
                          )}
                          {logoRueda ? 'Cambiar Logo' : 'Subir Logo'}
                        </span>
                      </Button>
                    </label>
                    <p className="text-xs text-gray-500 mt-2">
                      Este logo aparecerá SOLO en vouchers de prestadores del convenio &quot;Rueda de Turismo Social&quot;.
                    </p>
                    <p className="text-xs text-gray-400">PNG, JPG o WEBP. Máximo 500KB.</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Migración de Datos */}
          <Card className="mt-6 border-emerald-200">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-emerald-700">
                <FileJson className="w-5 h-5" />
                Migración de Datos
              </CardTitle>
              <CardDescription>
                Exportá o importá categorías y prestadores. Útil para sincronizar datos entre entornos (preview → producción).
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-wrap gap-4">
                {/* Exportar */}
                <Button
                  onClick={handleExportarDatos}
                  disabled={exportandoDatos}
                  variant="outline"
                  className="border-emerald-300 text-emerald-700 hover:bg-emerald-50"
                  data-testid="export-datos-btn"
                >
                  {exportandoDatos ? (
                    <>
                      <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                      Exportando...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4 mr-2" />
                      Exportar Datos (JSON)
                    </>
                  )}
                </Button>
                
                {/* Importar */}
                <input
                  type="file"
                  ref={importFileRef}
                  accept=".json"
                  onChange={handleImportarDatos}
                  className="hidden"
                  id="import-datos-file"
                />
                <Button
                  onClick={() => importFileRef.current?.click()}
                  disabled={importandoDatos}
                  className="bg-emerald-600 hover:bg-emerald-700"
                  data-testid="import-datos-btn"
                >
                  {importandoDatos ? (
                    <>
                      <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                      Importando...
                    </>
                  ) : (
                    <>
                      <Upload className="w-4 h-4 mr-2" />
                      Importar Datos (JSON)
                    </>
                  )}
                </Button>
                
                {/* Limpiar Duplicados */}
                <Button
                  onClick={async () => {
                    if (!window.confirm('¿Limpiar duplicados? Esto eliminará prestadores duplicados manteniendo el que tenga datos más completos.')) return;
                    try {
                      const headers = { Authorization: `Bearer ${getToken()}` };
                      const res = await axios.post(`${API_URL}/beneficios/admin/limpiar-duplicados`, {}, { headers });
                      setSuccess(`Limpieza completada: ${res.data.headers_eliminados} headers y ${res.data.duplicados_eliminados} duplicados eliminados`);
                      cargarDatos();
                    } catch (err) {
                      setError('Error al limpiar duplicados: ' + (err.response?.data?.detail || err.message));
                    }
                  }}
                  variant="outline"
                  className="border-red-300 text-red-600 hover:bg-red-50"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Limpiar Duplicados
                </Button>
              </div>
              
              <div className="mt-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
                <p className="text-sm text-amber-800">
                  <strong>Nota:</strong> Al importar, los datos existentes con el mismo nombre (normalizado) se actualizarán. 
                  Los nuevos se insertarán. Use "Limpiar Duplicados" para eliminar registros repetidos.
                </p>
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Modal Categoría */}
      <Dialog open={showCategoriaModal} onOpenChange={setShowCategoriaModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editingCategoria ? 'Editar Categoría' : 'Nueva Categoría'}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Nombre *</Label>
              <Input
                value={categoriaForm.nombre}
                onChange={(e) => setCategoriaForm({...categoriaForm, nombre: e.target.value})}
                placeholder="Ej: Hotelería"
              />
            </div>
            
            <div>
              <Label>Descripción</Label>
              <Input
                value={categoriaForm.descripcion}
                onChange={(e) => setCategoriaForm({...categoriaForm, descripcion: e.target.value})}
                placeholder="Descripción opcional"
              />
            </div>
            
            <div>
              <Label>Icono</Label>
              <Select
                value={categoriaForm.icono}
                onValueChange={(v) => setCategoriaForm({...categoriaForm, icono: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {iconOptions.map((opt) => {
                    const IconComp = iconMap[opt.value];
                    return (
                      <SelectItem key={opt.value} value={opt.value}>
                        <div className="flex items-center gap-2">
                          <IconComp className="w-4 h-4" />
                          {opt.label}
                        </div>
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <Label>Orden</Label>
              <Input
                type="number"
                value={categoriaForm.orden}
                onChange={(e) => setCategoriaForm({...categoriaForm, orden: parseInt(e.target.value) || 0})}
              />
            </div>
            
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="cat-activa"
                checked={categoriaForm.activa}
                onChange={(e) => setCategoriaForm({...categoriaForm, activa: e.target.checked})}
              />
              <Label htmlFor="cat-activa">Categoría activa</Label>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowCategoriaModal(false)}>
              Cancelar
            </Button>
            <Button onClick={guardarCategoria} disabled={saving}>
              {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
              Guardar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Prestador */}
      <Dialog open={showPrestadorModal} onOpenChange={setShowPrestadorModal}>
        <DialogContent className="max-w-7xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              {editingPrestador ? 'Editar Prestador' : 'Nuevo Prestador'}
            </DialogTitle>
          </DialogHeader>
          
          {/* Layout 3 columnas: form (2) + preview sticky (1) */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* ========== INFORMACIÓN BÁSICA ========== */}
            <div className="col-span-2 text-sm font-semibold text-gray-700 border-b pb-1 bg-green-50 px-2 py-1 rounded">
              📋 Información Básica
            </div>
            
            <div className="col-span-2">
              <Label>Nombre del Prestador *</Label>
              <Input
                value={prestadorForm.nombre}
                onChange={(e) => setPrestadorForm({...prestadorForm, nombre: e.target.value})}
                placeholder="Ej: Hotel Los Pinos"
              />
            </div>
            
            <div>
              <Label>Categoría *</Label>
              <Select
                value={prestadorForm.categoria_id}
                onValueChange={(v) => setPrestadorForm({...prestadorForm, categoria_id: v})}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Seleccionar categoría" />
                </SelectTrigger>
                <SelectContent>
                  {categorias.map((cat) => (
                    <SelectItem key={cat.id} value={cat.id}>
                      {cat.nombre}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <Label>Origen del Convenio</Label>
              <Select
                value={prestadorForm.origen}
                onValueChange={(v) => setPrestadorForm({...prestadorForm, origen: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {origenOptions.map((opt) => (
                    <SelectItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            <div className="col-span-2">
              <Label>Descripción breve (destacado verde en tarjeta y detalle) *</Label>
              <Textarea
                value={prestadorForm.descripcion}
                onChange={(e) => setPrestadorForm({...prestadorForm, descripcion: e.target.value})}
                placeholder="Descripción corta que aparece destacada en verde..."
                rows={2}
              />
            </div>
            
            <div className="col-span-2">
              <Label>Beneficio / Descuento *</Label>
              <Input
                value={prestadorForm.beneficio}
                onChange={(e) => setPrestadorForm({...prestadorForm, beneficio: e.target.value})}
                placeholder="Ej: 20% de descuento en alojamiento"
              />
            </div>

            {/* ========== CONTENIDO DE LA PÁGINA DE DETALLE ========== */}
            <div className="col-span-2 text-sm font-semibold text-gray-700 border-b pb-1 mt-4 bg-blue-50 px-2 py-1 rounded">
              📄 Contenido de la Página de Detalle
            </div>
            
            <div className="col-span-2">
              <Label>Descripción - Párrafo 1</Label>
              <Textarea
                value={prestadorForm.descripcion_parrafo1}
                onChange={(e) => setPrestadorForm({...prestadorForm, descripcion_parrafo1: e.target.value})}
                placeholder="Primer párrafo de descripción detallada..."
                rows={4}
              />
              <p className="text-xs text-gray-500 mt-1">
                Formato: **negrita**, *cursiva*, - item de lista. Los saltos de línea (Enter) se respetan.
              </p>
            </div>
            
            <div className="col-span-2">
              <Label>Imagen Principal (se muestra centrada después del párrafo 1)</Label>
              <div className="mt-2 space-y-3">
                {/* Preview de imagen actual */}
                {prestadorForm.imagen_principal && (
                  <div className="flex justify-center">
                    <div className="relative">
                      <img 
                        src={prestadorForm.imagen_principal} 
                        alt="Preview" 
                        className="max-h-48 rounded border"
                        onError={(e) => e.target.style.display = 'none'}
                      />
                      <button
                        type="button"
                        onClick={async () => {
                          if (editingPrestador) {
                            try {
                              await axios.delete(
                                `${API_URL}/beneficios/prestadores/${editingPrestador.id}/imagen-principal`,
                                { headers: { Authorization: `Bearer ${getToken()}` } }
                              );
                              setPrestadorForm({...prestadorForm, imagen_principal: ''});
                              setSuccess('Imagen eliminada');
                            } catch (err) {
                              setError('Error al eliminar imagen');
                            }
                          } else {
                            setPrestadorForm({...prestadorForm, imagen_principal: ''});
                          }
                        }}
                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                )}
                
                {/* Opciones de carga */}
                <div className="flex gap-3 items-center">
                  {/* Subir archivo */}
                  <div>
                    <input
                      type="file"
                      id="imagen-principal-upload"
                      accept="image/png,image/jpeg,image/jpg,image/webp,image/gif"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files?.[0];
                        if (!file) return;
                        
                        if (file.size > 1024 * 1024) {
                          setError('La imagen no debe superar 1MB');
                          return;
                        }
                        
                        if (editingPrestador) {
                          setSaving(true);
                          const formData = new FormData();
                          formData.append('imagen', file);
                          try {
                            const res = await axios.post(
                              `${API_URL}/beneficios/prestadores/${editingPrestador.id}/imagen-principal`,
                              formData,
                              { headers: { Authorization: `Bearer ${getToken()}` } }
                            );
                            setPrestadorForm({...prestadorForm, imagen_principal: res.data.imagen_url});
                            setSuccess('Imagen subida');
                          } catch (err) {
                            setError('Error al subir imagen');
                          } finally {
                            setSaving(false);
                          }
                        } else {
                          const reader = new FileReader();
                          reader.onload = (event) => {
                            setPrestadorForm({...prestadorForm, imagen_principal: event.target.result});
                          };
                          reader.readAsDataURL(file);
                        }
                        e.target.value = '';
                      }}
                    />
                    <label 
                      htmlFor="imagen-principal-upload"
                      className="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white px-4 py-2 hover:bg-gray-50 cursor-pointer"
                    >
                      <Upload className="w-4 h-4 mr-2" />
                      Subir imagen
                    </label>
                  </div>
                  
                  <span className="text-gray-400">o</span>
                  
                  {/* Pegar URL */}
                  <div className="flex-1">
                    <Input
                      value={prestadorForm.imagen_principal?.startsWith('data:') ? '' : prestadorForm.imagen_principal}
                      onChange={(e) => setPrestadorForm({...prestadorForm, imagen_principal: e.target.value})}
                      placeholder="Pegar URL de imagen (https://...)"
                    />
                  </div>
                </div>
                <p className="text-xs text-gray-500">Formatos: PNG, JPG, WEBP. Máximo 1MB.</p>
              </div>
            </div>
            
            <div className="col-span-2">
              <Label>Descripción - Párrafo 2</Label>
              <Textarea
                value={prestadorForm.descripcion_parrafo2}
                onChange={(e) => setPrestadorForm({...prestadorForm, descripcion_parrafo2: e.target.value})}
                placeholder="Segundo párrafo de descripción (aparece después de la imagen)..."
                rows={4}
              />
              <p className="text-xs text-gray-500 mt-1">
                Formato: **negrita**, *cursiva*, - item de lista. Los saltos de línea (Enter) se respetan.
              </p>
            </div>
            
            <div className="col-span-2">
              <Label>Detalles del Beneficio</Label>
              <Textarea
                value={prestadorForm.detalles_beneficio}
                onChange={(e) => setPrestadorForm({...prestadorForm, detalles_beneficio: e.target.value})}
                placeholder="Información adicional sobre el beneficio..."
                rows={3}
              />
              <p className="text-xs text-gray-500 mt-1">
                Formato: **negrita**, *cursiva*, - lista. Los saltos de línea se respetan.
              </p>
            </div>
            
            {/* ========== UBICACIÓN ========== */}
            <div className="col-span-2 text-sm font-semibold text-gray-700 border-b pb-1 mt-4 bg-amber-50 px-2 py-1 rounded">
              📍 Ubicación
            </div>
            
            <div className="col-span-2">
              <Label>Dirección</Label>
              <Input
                value={prestadorForm.direccion}
                onChange={(e) => setPrestadorForm({...prestadorForm, direccion: e.target.value})}
                placeholder="Ej: Av. San Martín 1234"
              />
            </div>
            
            <div>
              <Label>Localidad</Label>
              <Input
                value={prestadorForm.localidad}
                onChange={(e) => setPrestadorForm({...prestadorForm, localidad: e.target.value})}
                placeholder="Ej: Lomas de Zamora"
              />
            </div>
            
            <div>
              <Label>Provincia</Label>
              <Input
                value={prestadorForm.provincia}
                onChange={(e) => setPrestadorForm({...prestadorForm, provincia: e.target.value})}
                placeholder="Ej: Buenos Aires"
              />
            </div>
            
            {/* ========== INFORMACIÓN DE CONTACTO ========== */}
            <div className="col-span-2 text-sm font-semibold text-gray-700 border-b pb-1 mt-4 bg-cyan-50 px-2 py-1 rounded">
              📞 Información de Contacto
            </div>
            
            <div>
              <Label>Teléfono</Label>
              <Input
                value={prestadorForm.telefono}
                onChange={(e) => setPrestadorForm({...prestadorForm, telefono: e.target.value})}
                placeholder="Ej: (011) 4242-1234"
              />
            </div>
            
            <div>
              <Label>Email</Label>
              <Input
                type="email"
                value={prestadorForm.email}
                onChange={(e) => setPrestadorForm({...prestadorForm, email: e.target.value})}
                placeholder="Ej: contacto@empresa.com"
              />
            </div>
            
            <div>
              <Label>WhatsApp</Label>
              <Input
                value={prestadorForm.whatsapp}
                onChange={(e) => setPrestadorForm({...prestadorForm, whatsapp: e.target.value})}
                placeholder="Ej: +54 11 1234-5678"
              />
            </div>
            
            <div>
              <Label>Sitio Web</Label>
              <Input
                value={prestadorForm.sitio_web}
                onChange={(e) => setPrestadorForm({...prestadorForm, sitio_web: e.target.value})}
                placeholder="Ej: www.empresa.com"
              />
            </div>
            
            <div className="col-span-2">
              <Label>Horarios de Atención</Label>
              <Input
                value={prestadorForm.horarios}
                onChange={(e) => setPrestadorForm({...prestadorForm, horarios: e.target.value})}
                placeholder="Ej: Lun a Vie 9 a 18hs"
              />
            </div>
            
            <div className="col-span-2">
              <Label>Instrucciones para acceder al beneficio</Label>
              <Textarea
                value={prestadorForm.instrucciones}
                onChange={(e) => setPrestadorForm({...prestadorForm, instrucciones: e.target.value})}
                placeholder="Ej: Mencionar que venís del Colegio al momento de reservar..."
                rows={2}
              />
            </div>
            
            <div className="col-span-2">
              <Label>Precios y Tarifas</Label>
              <Textarea
                value={prestadorForm.precios_tarifas || prestadorForm.precios}
                onChange={(e) => setPrestadorForm({...prestadorForm, precios_tarifas: e.target.value, precios: e.target.value})}
                placeholder="Detalle de precios, tarifas, temporadas..."
                rows={5}
              />
              <p className="text-xs text-gray-500 mt-1">
                Formato: **negrita**, *cursiva*, - lista. Para tablas usar: | Col1 | Col2 | (ver ejemplo abajo)
              </p>
              <details className="text-xs text-gray-400 mt-1">
                <summary className="cursor-pointer hover:text-gray-600">Ver ejemplo de tabla</summary>
                <pre className="mt-1 p-2 bg-gray-100 rounded text-xs overflow-x-auto">
{`| Servicio | Precio |
|----------|--------|
| Básico   | $1000  |
| Premium  | $2000  |`}
                </pre>
              </details>
            </div>
            
            <div className="col-span-2">
              <Label>Condiciones del Beneficio</Label>
              <Textarea
                value={prestadorForm.condiciones}
                onChange={(e) => setPrestadorForm({...prestadorForm, condiciones: e.target.value})}
                placeholder="Restricciones, fechas de validez, requisitos..."
                rows={3}
              />
              <p className="text-xs text-gray-500 mt-1">
                Formato: **negrita**, *cursiva*, - lista. Los saltos de línea se respetan.
              </p>
            </div>

            {/* ========== SISTEMA DE BOTONES PERSONALIZABLES ========== */}
            <div className="col-span-2 text-sm font-semibold text-gray-700 border-b pb-1 mt-4 bg-purple-50 px-2 py-1 rounded">
              🔘 Botones de Acción (máximo 3)
            </div>
            
            <div className="col-span-2 text-xs text-gray-500 mb-2">
              Configurá hasta 3 botones que aparecerán en la página de detalle del prestador. Si no configurás ninguno, se mostrará el botón "Generar Voucher" por defecto.
            </div>
            
            {/* Título de la sección de botones */}
            <div className="col-span-2">
              <Label>Título de la sección</Label>
              <Select
                value={prestadorForm.titulo_seccion_botones || 'como_acceder'}
                onValueChange={(v) => setPrestadorForm({...prestadorForm, titulo_seccion_botones: v})}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Seleccionar título" />
                </SelectTrigger>
                <SelectContent>
                  {titulosSeccionBotones.map((opt) => (
                    <SelectItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            {/* Botón 1 */}
            <div className="col-span-2 p-3 bg-gray-50 rounded-lg space-y-3">
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm">Botón 1</span>
                <Select
                  value={prestadorForm.boton1_tipo}
                  onValueChange={(v) => setPrestadorForm({...prestadorForm, boton1_tipo: v, boton1_config: {}})}
                >
                  <SelectTrigger className="flex-1">
                    <SelectValue placeholder="Seleccionar tipo de botón" />
                  </SelectTrigger>
                  <SelectContent>
                    {tiposBotones.map((opt) => (
                      <SelectItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              
              {/* Campos específicos según tipo de botón 1 */}
              {prestadorForm.boton1_tipo === 'codigo_descuento' && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pl-4 border-l-2 border-purple-300">
                  <div>
                    <Label className="text-xs">Código de descuento *</Label>
                    <Input
                      value={prestadorForm.boton1_config?.codigo || ''}
                      onChange={(e) => setPrestadorForm({
                        ...prestadorForm, 
                        boton1_config: {...prestadorForm.boton1_config, codigo: e.target.value}
                      })}
                      placeholder="Ej: DESCUENTO20"
                    />
                  </div>
                  <div className="col-span-2">
                    <Label className="text-xs">Instrucciones para el usuario</Label>
                    <Textarea
                      value={prestadorForm.boton1_config?.instrucciones || ''}
                      onChange={(e) => setPrestadorForm({
                        ...prestadorForm, 
                        boton1_config: {...prestadorForm.boton1_config, instrucciones: e.target.value}
                      })}
                      placeholder="Ej: Ingresá este código al finalizar tu compra en www.ejemplo.com"
                      rows={2}
                    />
                  </div>
                </div>
              )}
              
              {prestadorForm.boton1_tipo === 'whatsapp' && (
                <div className="pl-4 border-l-2 border-green-300">
                  <Label className="text-xs">Número de WhatsApp *</Label>
                  <Input
                    value={prestadorForm.boton1_config?.numero || ''}
                    onChange={(e) => setPrestadorForm({
                      ...prestadorForm, 
                      boton1_config: {...prestadorForm.boton1_config, numero: e.target.value}
                    })}
                    placeholder="Ej: 5491112345678 (sin + ni espacios)"
                  />
                </div>
              )}
              
              {prestadorForm.boton1_tipo === 'web_prestador' && (
                <div className="pl-4 border-l-2 border-blue-300">
                  <Label className="text-xs">URL de la página web *</Label>
                  <Input
                    value={prestadorForm.boton1_config?.url || ''}
                    onChange={(e) => setPrestadorForm({
                      ...prestadorForm, 
                      boton1_config: {...prestadorForm.boton1_config, url: e.target.value}
                    })}
                    placeholder="Ej: https://www.empresa.com"
                  />
                </div>
              )}
            </div>
            
            {/* Botón 2 */}
            <div className="col-span-2 p-3 bg-gray-50 rounded-lg space-y-3">
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm">Botón 2</span>
                <Select
                  value={prestadorForm.boton2_tipo}
                  onValueChange={(v) => setPrestadorForm({...prestadorForm, boton2_tipo: v, boton2_config: {}})}
                >
                  <SelectTrigger className="flex-1">
                    <SelectValue placeholder="Seleccionar tipo de botón" />
                  </SelectTrigger>
                  <SelectContent>
                    {tiposBotones.map((opt) => (
                      <SelectItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              
              {prestadorForm.boton2_tipo === 'codigo_descuento' && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pl-4 border-l-2 border-purple-300">
                  <div>
                    <Label className="text-xs">Código de descuento *</Label>
                    <Input
                      value={prestadorForm.boton2_config?.codigo || ''}
                      onChange={(e) => setPrestadorForm({
                        ...prestadorForm, 
                        boton2_config: {...prestadorForm.boton2_config, codigo: e.target.value}
                      })}
                      placeholder="Ej: DESCUENTO20"
                    />
                  </div>
                  <div className="col-span-2">
                    <Label className="text-xs">Instrucciones para el usuario</Label>
                    <Textarea
                      value={prestadorForm.boton2_config?.instrucciones || ''}
                      onChange={(e) => setPrestadorForm({
                        ...prestadorForm, 
                        boton2_config: {...prestadorForm.boton2_config, instrucciones: e.target.value}
                      })}
                      placeholder="Ej: Ingresá este código al finalizar tu compra"
                      rows={2}
                    />
                  </div>
                </div>
              )}
              
              {prestadorForm.boton2_tipo === 'whatsapp' && (
                <div className="pl-4 border-l-2 border-green-300">
                  <Label className="text-xs">Número de WhatsApp *</Label>
                  <Input
                    value={prestadorForm.boton2_config?.numero || ''}
                    onChange={(e) => setPrestadorForm({
                      ...prestadorForm, 
                      boton2_config: {...prestadorForm.boton2_config, numero: e.target.value}
                    })}
                    placeholder="Ej: 5491112345678"
                  />
                </div>
              )}
              
              {prestadorForm.boton2_tipo === 'web_prestador' && (
                <div className="pl-4 border-l-2 border-blue-300">
                  <Label className="text-xs">URL de la página web *</Label>
                  <Input
                    value={prestadorForm.boton2_config?.url || ''}
                    onChange={(e) => setPrestadorForm({
                      ...prestadorForm, 
                      boton2_config: {...prestadorForm.boton2_config, url: e.target.value}
                    })}
                    placeholder="Ej: https://www.empresa.com"
                  />
                </div>
              )}
            </div>
            
            {/* Botón 3 */}
            <div className="col-span-2 p-3 bg-gray-50 rounded-lg space-y-3">
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm">Botón 3</span>
                <Select
                  value={prestadorForm.boton3_tipo}
                  onValueChange={(v) => setPrestadorForm({...prestadorForm, boton3_tipo: v, boton3_config: {}})}
                >
                  <SelectTrigger className="flex-1">
                    <SelectValue placeholder="Seleccionar tipo de botón" />
                  </SelectTrigger>
                  <SelectContent>
                    {tiposBotones.map((opt) => (
                      <SelectItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              
              {prestadorForm.boton3_tipo === 'codigo_descuento' && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pl-4 border-l-2 border-purple-300">
                  <div>
                    <Label className="text-xs">Código de descuento *</Label>
                    <Input
                      value={prestadorForm.boton3_config?.codigo || ''}
                      onChange={(e) => setPrestadorForm({
                        ...prestadorForm, 
                        boton3_config: {...prestadorForm.boton3_config, codigo: e.target.value}
                      })}
                      placeholder="Ej: DESCUENTO20"
                    />
                  </div>
                  <div className="col-span-2">
                    <Label className="text-xs">Instrucciones para el usuario</Label>
                    <Textarea
                      value={prestadorForm.boton3_config?.instrucciones || ''}
                      onChange={(e) => setPrestadorForm({
                        ...prestadorForm, 
                        boton3_config: {...prestadorForm.boton3_config, instrucciones: e.target.value}
                      })}
                      placeholder="Ej: Ingresá este código al finalizar tu compra"
                      rows={2}
                    />
                  </div>
                </div>
              )}
              
              {prestadorForm.boton3_tipo === 'whatsapp' && (
                <div className="pl-4 border-l-2 border-green-300">
                  <Label className="text-xs">Número de WhatsApp *</Label>
                  <Input
                    value={prestadorForm.boton3_config?.numero || ''}
                    onChange={(e) => setPrestadorForm({
                      ...prestadorForm, 
                      boton3_config: {...prestadorForm.boton3_config, numero: e.target.value}
                    })}
                    placeholder="Ej: 5491112345678"
                  />
                </div>
              )}
              
              {prestadorForm.boton3_tipo === 'web_prestador' && (
                <div className="pl-4 border-l-2 border-blue-300">
                  <Label className="text-xs">URL de la página web *</Label>
                  <Input
                    value={prestadorForm.boton3_config?.url || ''}
                    onChange={(e) => setPrestadorForm({
                      ...prestadorForm, 
                      boton3_config: {...prestadorForm.boton3_config, url: e.target.value}
                    })}
                    placeholder="Ej: https://www.empresa.com"
                  />
                </div>
              )}
            </div>

            {/* Logo */}
            <div className="col-span-2 text-sm font-semibold text-gray-700 border-b pb-1 mt-4 bg-gray-50 px-2 py-1 rounded">
              🖼️ Logo e Imágenes
            </div>
            
            <div className="col-span-2">
              <Label>Logo del Prestador</Label>
              <div className="flex items-center gap-4 mt-2">
                {prestadorForm.logo_url ? (
                  <div className="relative">
                    <img 
                      src={prestadorForm.logo_url} 
                      alt="Logo" 
                      className="w-16 h-16 rounded-full object-cover border-2 border-gray-200"
                    />
                    <button
                      type="button"
                      onClick={() => setPrestadorForm({...prestadorForm, logo_url: ''})}
                      className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-0.5 hover:bg-red-600"
                    >
                      <X className="w-3 h-3" />
                    </button>
                  </div>
                ) : (
                  <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center border-2 border-dashed border-gray-300">
                    <Image className="w-6 h-6 text-gray-400" />
                  </div>
                )}
                
                <div className="flex-1">
                  <input
                    type="file"
                    id="logo-upload"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      
                      // Validar que sea una imagen (cualquier formato de imagen)
                      if (!file.type.startsWith('image/')) {
                        setError('El archivo debe ser una imagen (PNG, JPG, WEBP, GIF, etc.)');
                        return;
                      }
                      
                      if (file.size > 500 * 1024) {
                        setError('La imagen no debe superar 500KB');
                        return;
                      }
                      
                      if (editingPrestador) {
                        // Prestador existente: subir inmediatamente
                        setSaving(true);
                        const formData = new FormData();
                        formData.append('logo', file);
                        try {
                          const res = await axios.post(
                            `${API_URL}/beneficios/prestadores/${editingPrestador.id}/logo`,
                            formData,
                            { headers: { Authorization: `Bearer ${getToken()}` } }
                          );
                          setPrestadorForm({...prestadorForm, logo_url: res.data.logo_url});
                          setSuccess('Logo actualizado');
                        } catch (err) {
                          console.error('Error uploading logo:', err);
                          setError('Error al subir el logo: ' + (err.response?.data?.detail || err.message));
                        } finally {
                          setSaving(false);
                        }
                      } else {
                        // Nuevo prestador: guardar archivo para subir después de crear
                        setPendingLogoFile(file);
                        // Mostrar preview
                        const reader = new FileReader();
                        reader.onload = (event) => {
                          setPrestadorForm({...prestadorForm, logo_url: event.target.result});
                        };
                        reader.readAsDataURL(file);
                        setSuccess('Logo cargado. Se subirá al guardar el prestador.');
                      }
                      e.target.value = '';
                    }}
                  />
                  <label 
                    htmlFor="logo-upload"
                    className="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white px-4 py-2 hover:bg-gray-50 cursor-pointer"
                  >
                    <Upload className="w-4 h-4 mr-2" />
                    {prestadorForm.logo_url ? 'Cambiar Logo' : 'Subir Logo'}
                  </label>
                  <p className="text-xs text-gray-500 mt-1">PNG, JPG, WEBP o GIF. Máximo 500KB.</p>
                </div>
              </div>
            </div>
            
            {/* Galería de imágenes */}
            <div className="col-span-2">
              <Label>Galería de Imágenes (adicionales)</Label>
              <p className="text-xs text-gray-500 mb-2">
                Imágenes adicionales que se mostrarán en la galería de la página de detalle.
              </p>
              
              <div className="flex flex-wrap gap-3 mt-2">
                {prestadorForm.imagenes?.map((img, idx) => (
                  <div key={idx} className="relative group">
                    <img 
                      src={img} 
                      alt={`Imagen ${idx + 1}`} 
                      className="w-24 h-24 object-cover rounded-lg border border-gray-200"
                    />
                    <button
                      type="button"
                      onClick={async () => {
                        if (editingPrestador) {
                          try {
                            await axios.delete(
                              `${API_URL}/beneficios/prestadores/${editingPrestador.id}/imagenes/${idx}`,
                              { headers: { Authorization: `Bearer ${getToken()}` } }
                            );
                            const newImagenes = [...prestadorForm.imagenes];
                            newImagenes.splice(idx, 1);
                            setPrestadorForm({...prestadorForm, imagenes: newImagenes});
                            setSuccess('Imagen eliminada');
                          } catch (err) {
                            setError('Error al eliminar imagen');
                          }
                        } else {
                          const newImagenes = [...prestadorForm.imagenes];
                          newImagenes.splice(idx, 1);
                          setPrestadorForm({...prestadorForm, imagenes: newImagenes});
                        }
                      }}
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <X className="w-3 h-3" />
                    </button>
                  </div>
                ))}
                
                {/* Botón para agregar imagen */}
                <div className="w-24 h-24">
                  <input
                    type="file"
                    id="gallery-upload"
                    accept="image/png,image/jpeg,image/jpg,image/webp,image/gif"
                    className="hidden"
                    disabled={uploadingGallery}
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      
                      if (file.size > 1024 * 1024) {
                        setError('La imagen no debe superar 1MB');
                        return;
                      }
                      
                      if (editingPrestador) {
                        setUploadingGallery(true);
                        const formData = new FormData();
                        formData.append('imagen', file);
                        try {
                          const res = await axios.post(
                            `${API_URL}/beneficios/prestadores/${editingPrestador.id}/imagenes`,
                            formData,
                            { headers: { Authorization: `Bearer ${getToken()}` } }
                          );
                          setPrestadorForm({
                            ...prestadorForm, 
                            imagenes: [...(prestadorForm.imagenes || []), res.data.imagen_url]
                          });
                          setSuccess('Imagen agregada');
                        } catch (err) {
                          setError('Error al subir imagen');
                        } finally {
                          setUploadingGallery(false);
                        }
                      } else {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                          setPrestadorForm({
                            ...prestadorForm, 
                            imagenes: [...(prestadorForm.imagenes || []), event.target.result]
                          });
                        };
                        reader.readAsDataURL(file);
                      }
                      e.target.value = '';
                    }}
                  />
                  <label 
                    htmlFor="gallery-upload" 
                    className="w-full h-full flex flex-col items-center justify-center bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
                  >
                    {uploadingGallery ? (
                      <Loader2 className="w-6 h-6 text-gray-400 animate-spin" />
                    ) : (
                      <>
                        <Plus className="w-6 h-6 text-gray-400" />
                        <span className="text-xs text-gray-400 mt-1">Agregar</span>
                      </>
                    )}
                  </label>
                </div>
              </div>
            </div>
            
            <div className="col-span-2 flex items-center gap-6 mt-4">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="prest-activo"
                  checked={prestadorForm.activo}
                  onChange={(e) => setPrestadorForm({...prestadorForm, activo: e.target.checked})}
                />
                <Label htmlFor="prest-activo">Prestador activo</Label>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="prest-destacado"
                  checked={!!prestadorForm.destacado}
                  onChange={(e) => setPrestadorForm({...prestadorForm, destacado: e.target.checked})}
                  data-testid="prest-destacado"
                />
                <Label htmlFor="prest-destacado" className="flex items-center gap-1">
                  ⭐ Destacado
                  <span className="text-xs text-gray-400 font-normal">(aparece en el carrusel del home)</span>
                </Label>
              </div>
            </div>

            {/* ========== PAQUETES TURÍSTICOS (solo si la categoría es "Paquetes Turísticos") ========== */}
            {(() => {
              const catSeleccionada = categorias.find(c => c.id === prestadorForm.categoria_id);
              const esPaqueteTuristico =
                catSeleccionada &&
                catSeleccionada.nombre &&
                catSeleccionada.nombre
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .includes('paquete');
              if (!esPaqueteTuristico) return null;
              return (
                <PaquetesTuristicosManager
                  paquetes={prestadorForm.paquetes || []}
                  onChange={(paquetes) => setPrestadorForm({...prestadorForm, paquetes})}
                />
              );
            })()}
              </div>
            </div>

            {/* Sidebar: Preview en vivo */}
            <aside className="lg:col-span-1">
              <div className="lg:sticky lg:top-0 space-y-3">
                <div className="flex items-center gap-2 pb-2 border-b border-gray-200">
                  <Eye className="w-4 h-4 text-purple-600" />
                  <p className="text-sm font-semibold text-gray-700">Preview en vivo</p>
                  <span className="text-[10px] text-gray-400 uppercase tracking-wider ml-auto">Home pública</span>
                </div>
                <PrestadorPreviewCard prestadorForm={prestadorForm} categorias={categorias} iconMap={iconMap} />
                <p className="text-[11px] text-gray-500 leading-relaxed">
                  Así se verá la tarjeta del prestador en la home de la Guía TS+ para los matriculados. Se actualiza mientras editás.
                </p>
              </div>
            </aside>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowPrestadorModal(false)} disabled={saving}>
              Cancelar
            </Button>
            <Button 
              type="button"
              onClick={guardarPrestador} 
              disabled={saving}
              className="min-w-[100px]"
            >
              {saving ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  Guardando...
                </>
              ) : (
                'Guardar'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Análisis de Duplicados */}
      <Dialog open={showAnalisisModal} onOpenChange={setShowAnalisisModal}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <AlertCircle className="w-6 h-6 text-amber-500" />
              Se detectaron duplicados
            </DialogTitle>
            <DialogDescription>
              Se encontraron {analisisImport?.resumen?.prestadores_duplicados || 0} posibles duplicados. 
              Por favor, decidí qué hacer con cada uno.
            </DialogDescription>
          </DialogHeader>
          
          {analisisImport && (
            <div className="space-y-4">
              {/* Resumen */}
              <div className="bg-gray-50 rounded-lg p-4 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div className="text-center">
                  <div className="text-2xl font-bold text-emerald-600">{analisisImport.resumen.prestadores_nuevos}</div>
                  <div className="text-gray-500">Nuevos</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-amber-600">{analisisImport.resumen.prestadores_duplicados}</div>
                  <div className="text-gray-500">Duplicados</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600">{analisisImport.resumen.categorias_nuevas}</div>
                  <div className="text-gray-500">Categorías nuevas</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-gray-600">{analisisImport.resumen.total_prestadores}</div>
                  <div className="text-gray-500">Total a importar</div>
                </div>
              </div>

              {/* Acciones masivas */}
              {analisisImport.prestadores.duplicados.length > 1 && (
                <div className="flex gap-2 items-center justify-end border-b pb-3">
                  <span className="text-sm text-gray-500">Aplicar a todos:</span>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => handleAplicarDecisionATodos('omitir')}
                    className="text-xs"
                  >
                    Omitir todos
                  </Button>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => handleAplicarDecisionATodos('actualizar')}
                    className="text-xs"
                  >
                    Actualizar todos
                  </Button>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => handleAplicarDecisionATodos('insertar')}
                    className="text-xs"
                  >
                    Insertar todos como nuevos
                  </Button>
                </div>
              )}

              {/* Lista de duplicados */}
              <div className="space-y-3 max-h-[400px] overflow-y-auto">
                {analisisImport.prestadores.duplicados.map((dup, idx) => (
                  <div key={idx} className="border rounded-lg p-4 bg-amber-50/50">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1 space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xs bg-amber-200 text-amber-800 px-2 py-0.5 rounded">
                            {dup.motivo_texto}
                          </span>
                        </div>
                        
                        {/* Comparación lado a lado */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                          <div className="bg-white p-3 rounded border">
                            <div className="font-medium text-emerald-700 mb-2 flex items-center gap-1">
                              <Plus className="w-4 h-4" /> Nuevo (a importar)
                            </div>
                            <div className="space-y-1 text-gray-600">
                              <p><strong>Nombre:</strong> {dup.nuevo.nombre}</p>
                              <p><strong>Dirección:</strong> {dup.nuevo.direccion || '-'}</p>
                              <p><strong>Localidad:</strong> {dup.nuevo.localidad || '-'}</p>
                              <p><strong>Provincia:</strong> {dup.nuevo.provincia || '-'}</p>
                              <p><strong>Teléfono:</strong> {dup.nuevo.telefono || '-'}</p>
                            </div>
                          </div>
                          <div className="bg-white p-3 rounded border">
                            <div className="font-medium text-blue-700 mb-2 flex items-center gap-1">
                              <Database className="w-4 h-4" /> Existente (en BD)
                            </div>
                            <div className="space-y-1 text-gray-600">
                              <p><strong>Nombre:</strong> {dup.existente.nombre}</p>
                              <p><strong>Dirección:</strong> {dup.existente.direccion || '-'}</p>
                              <p><strong>Localidad:</strong> {dup.existente.localidad || '-'}</p>
                              <p><strong>Provincia:</strong> {dup.existente.provincia || '-'}</p>
                              <p><strong>Teléfono:</strong> {dup.existente.telefono || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Selector de decisión */}
                      <div className="flex flex-col gap-1 min-w-[140px]">
                        <label className="text-xs text-gray-500 mb-1">¿Qué hacer?</label>
                        <select
                          value={decisionesDuplicados[dup.indice] || 'omitir'}
                          onChange={(e) => handleDecisionDuplicado(dup.indice, e.target.value)}
                          className="text-sm border rounded px-2 py-1.5 bg-white"
                        >
                          <option value="omitir">⏭️ Omitir</option>
                          <option value="actualizar">🔄 Actualizar existente</option>
                          <option value="insertar">➕ Insertar como nuevo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Resumen de decisiones */}
              <div className="bg-gray-100 rounded-lg p-3 text-sm">
                <div className="flex gap-4 justify-center">
                  <span>
                    <span className="font-medium text-gray-700">
                      {Object.values(decisionesDuplicados).filter(d => d === 'omitir').length}
                    </span>
                    <span className="text-gray-500"> a omitir</span>
                  </span>
                  <span>
                    <span className="font-medium text-blue-700">
                      {Object.values(decisionesDuplicados).filter(d => d === 'actualizar').length}
                    </span>
                    <span className="text-gray-500"> a actualizar</span>
                  </span>
                  <span>
                    <span className="font-medium text-emerald-700">
                      {Object.values(decisionesDuplicados).filter(d => d === 'insertar').length}
                    </span>
                    <span className="text-gray-500"> a insertar nuevos</span>
                  </span>
                </div>
              </div>
            </div>
          )}
          
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setShowAnalisisModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleConfirmarImportacion}
              disabled={importandoDatos}
              className="min-w-[150px]"
            >
              {importandoDatos ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  Importando...
                </>
              ) : (
                <>
                  <Upload className="w-4 h-4 mr-2" />
                  Confirmar Importación
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Resultado Importación */}
      <Dialog open={showImportResult} onOpenChange={setShowImportResult}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="text-center">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${
                importResult?.success ? 'bg-emerald-100' : 'bg-red-100'
              }`}>
                {importResult?.success ? (
                  <CheckCircle className="w-8 h-8 text-emerald-600" />
                ) : (
                  <AlertCircle className="w-8 h-8 text-red-600" />
                )}
              </div>
              {importResult?.success ? 'Importación Completada' : 'Error en la Importación'}
            </DialogTitle>
          </DialogHeader>
          {importResult && (
            <div className="space-y-3">
              <p className="text-center text-gray-600">{importResult.mensaje}</p>
              {importResult.estadisticas && (
                <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                  <div className="flex justify-between text-emerald-600">
                    <span>Categorías insertadas:</span>
                    <span className="font-medium">{importResult.estadisticas.categorias_insertadas}</span>
                  </div>
                  <div className="flex justify-between text-blue-600">
                    <span>Categorías actualizadas:</span>
                    <span className="font-medium">{importResult.estadisticas.categorias_actualizadas}</span>
                  </div>
                  <div className="flex justify-between text-emerald-600">
                    <span>Prestadores insertados:</span>
                    <span className="font-medium">{importResult.estadisticas.prestadores_insertados}</span>
                  </div>
                  <div className="flex justify-between text-blue-600">
                    <span>Prestadores actualizados:</span>
                    <span className="font-medium">{importResult.estadisticas.prestadores_actualizados}</span>
                  </div>
                  {importResult.estadisticas.prestadores_omitidos > 0 && (
                    <div className="flex justify-between text-gray-500">
                      <span>Prestadores omitidos:</span>
                      <span className="font-medium">{importResult.estadisticas.prestadores_omitidos}</span>
                    </div>
                  )}
                  {importResult.estadisticas.errores?.length > 0 && (
                    <div className="mt-2 pt-2 border-t text-red-600 text-sm">
                      Errores: {importResult.estadisticas.errores.length}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button onClick={() => setShowImportResult(false)} className="w-full">
              Aceptar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
